module.exports = __webpack_public_path__ + "static/media/person.2be09a65.png";